<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex == 1">
        <ActiveChestView :data-set="dataSet" @copyValue="copyValue" @chest-claim="chestClaim" @goToShare="goToShare" @goToChestUser="goToChestUser" />
    </div>
    <div v-if="themeStore.themeIndex == 2">
        <activeChestViewTwo :data-set="dataSet" @copyValue="copyValue" @chest-claim="chestClaim" @goToShare="goToShare" @goToChestUser="goToChestUser" />
    </div>
    <div v-if="themeStore.themeIndex == 3">
        <ActiveChestViewThree :data-set="dataSet" @copyValue="copyValue" @chest-claim="chestClaim" @goToShare="goToShare" @goToChestUser="goToChestUser" />
    </div>
    <div v-if="themeStore.themeIndex == 4">
        <ActiveChestViewFour :data-set="dataSet" @copyValue="copyValue" @chest-claim="chestClaim" @goToShare="goToShare" @goToChestUser="goToChestUser" />
    </div>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>
<script setup lang="ts">
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useRouter } from 'vue-router';
import { getActivityInformations } from '@/api/common';
import { useI18n } from 'vue-i18n';
import { activeTreasureClaim } from '@/api/activity';
import { useUserStore } from '@/stores/user';
import { Share } from '@capacitor/share';
import ActiveChestView from '@/themes/themeOne/activeChest/activeChestView.vue';
import activeChestViewTwo from '@/themes/themeTwo/activeChest/activeChestView.vue';
import ActiveChestViewThree from '@/themes/themeThree/activeChest/activeChestView.vue';
import ActiveChestViewFour from '@/themes/themeFour/activeChest/activeChestView.vue';
import { ActiveChestData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const userStore = useUserStore()
const { t } = useI18n()
const router = useRouter()
const loadingRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const amount = ref(0)
const flatIcon = ref('')
const rewardList = ref([])
const copyLink = ref('')
const userCount = ref(0)
const activityIntro = ref([])

const dataSet = computed<ActiveChestData>(() => ({
    copyLink: copyLink.value,
    userCount: userCount.value,
    activityIntro: activityIntro.value,
    rewardList: rewardList.value,
    amount: amount.value,
    flatIcon: flatIcon.value
}))

const copyValue = (value: any) => {
    if (value) {
        navigator.clipboard.writeText(value).then(() => {
            showSuccess(t('common.copied'))
            statusRef.value.open()
        }).catch(err => {
            console.error('Failed to copy: ', err)
        })
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "active_tresure_chest"
    }

    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        if (res?.data) {
            copyLink.value = res.data?.config?.link || ''
            userCount.value = res.data?.config?.valid_user_count || 0
            activityIntro.value = JSON.parse(res.data?.activityIntro)
            rewardList.value = res.data?.config?.reward_conf || []
            amount.value = res.data?.config?.reward_amount_total || 0
            flatIcon.value = res.data?.floatIcon || ''
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const chestClaim = () => {
    loadingRef.value.open()
    let data = {
        uid: userStore.id
    }
    activeTreasureClaim(data).then(res => {
        loadingRef.value.close()
        getActivityInfo()
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const goToShare = async () => {
    let shareLink = copyLink.value //localStorage.getItem('shareLink')
    try {
      if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });  
    } catch (error) {
        console.warn('Not supporting')
    }
}

const goToChestUser = () => {
    router.push('/sdchestuser')
}
onMounted(() => {
    getActivityInfo();
})
</script>
